import axios from 'axios';

const BASE_URL = process.env.REACT_APP_PRESSHUNT_AUTH_SERVICES_BASE_DOMAIN;

export const postIdTokenToSessionLogin = (idToken, csrfToken) => axios.post(`${BASE_URL}/api/sessionLogin`, {
  idToken,
  csrfToken,
});
